import redirect from "@rill/redirect";
import set from "@rill/set";
import rill from "rill";
import Billing from "./billing";
import Branding from "./branding";
import CoachBilling from "./coach-billing";
import CoachManageBilling from "./coach-manage-billing";
import ExerciseLibrary from "./exercise-library";
import Faqs from "./faqs";
import GymContract from "./gym-contract";
import GymLocations from "./gym-locations";
import ManageCoaches from "./manage-coaches";
import ManageCoaching from "./manage-coaching";
import Notifications from "./notifications";
import PerformInvoice from "./perform-invoice";
import Preferences from "./preferences";
import Profile from "./profile";
import Settings from "./settings";
import Subscription from "./subscription";
import YourProducts from "./your-products";

const SettingsController = (app) => {
  app.get("/settings", redirect("/dashboard/settings/profile")).at(
    "/settings/*",
    rill()
      .use(set("heading", ["Settings"]))
      .setup(Settings)
      .setup(Billing)
      .setup(CoachBilling)
      .setup(CoachManageBilling)
      .setup(ManageCoaches)
      .setup(ManageCoaching)
      .setup(Notifications)
      .setup(Faqs)
      .setup(Branding)
      // .setup(StorefrontScripts)
      .setup(GymContract)
      .setup(GymLocations)
      .setup(PerformInvoice)
      .setup(YourProducts)
      .setup(Profile)
      .setup(Preferences)
      .setup(ExerciseLibrary)
      .setup(Subscription)
  );
};

export default SettingsController;
